import { apiClient } from "./apiClient";

export const packerService = {
  /**
   * Create a new packer
   */
  createPacker: async (name: string) => {
    // Get Spain as default country (id: 1)
    const response = await apiClient.post("/packers/", {
      name,
      country: 1, // Spain by default
    });
    return response.data;
  },
};
